import { ComponentView, View } from "binder"
import { HorizontalLineViewModel } from "./horizontalLine-viewModel"

export class HorizontalLineView extends ComponentView<HorizontalLineViewModel>{
    GetViewUniqueId(): string {
        return "V-BAC3E2B1-B8BD-454B-A47E-C05977182647"
    }
    loadHtml(): string {
        let element = require('./horizontalLine.html').default;
        let style = require('./horizontalLine.less');
        return element;
    }
    constructor() {
       super();
    }
}
